<div class="header-utilities-panel" [style.--header-panel-height]="headerHeight">
  <itc-profile-info />
  <div class="header-utilities-panel__main">
    @for (navigationItem of settingsNavigationItems(); track navigationItem.id) {
      <a
        *itcPermission="navigationItem.permissions"
        kdsPrefetch
        class="header-utilities-panel__item"
        routerLinkActive="header-utilities-panel__item--active"
        [routerLink]="navigationItem.id"
        (isActiveChange)="setActiveTopNavigation(navigationItem.id, $event)"
        (click)="handleSettingsNavigationClick(navigationItem.id)"
      >
        <i [class]="navigationItem.iconClass"></i>
        <span class="header-utilities-panel__item-label">{{ navigationItem.labelTranslateKey | translate }}</span>
      </a>
    }
    <itc-theme-toggle-panel *itcPermission="Permission.ThemeSettingsView" />
    <itc-help-toggle-panel [(isOpen)]="isOpen" />
    <itc-notifications-toggle-panel *itcPermission="Permission.NotificationsView" />
  </div>
  <div class="header-utilities-panel__divider"></div>
  <a class="header-utilities-panel__logout" kdsPrefetch [routerLink]="ApplicationPath.Logout">
    <i class="header-utilities-panel__logout-icon fa-regular fa-arrow-right-from-bracket"></i>
    <span>{{ 'profile-menu.log-out' | translate }}</span>
  </a>
</div>
